var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: url(#_\u540D\u79F0\u672A\u8A2D\u5B9A\u30B0\u30E9\u30C7\u30FC\u30B7\u30E7\u30F3_2);\n      }\n\n      .st2 {\n        fill: url(#_\u540D\u79F0\u672A\u8A2D\u5B9A\u30B0\u30E9\u30C7\u30FC\u30B7\u30E7\u30F3_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_3",
    "data-name": "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3 3",
    x1: 56.49,
    y1: -23.34,
    x2: 56.49,
    y2: 121.29,
    gradientTransform: "translate(0 120.22) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84b12f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#5da335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#37953b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1e8e3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#168b43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3_2",
    "data-name": "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3 2",
    x1: 63.51,
    y1: 309.7,
    x2: 63.51,
    y2: 26.49,
    gradientTransform: "translate(0 120.22) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005c33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#066134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#127339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#198e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20913d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.97,7.03c-4.34-4.34-10.35-7.03-16.97-7.03H24C10.75,0,0,10.75,0,24v72.01C0,102.62,2.69,108.64,7.03,112.97L112.97,7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.03,112.97c4.34,4.34,10.35,7.03,16.97,7.03h72.01c13.26,0,24-10.75,24-24V24c0-6.62-2.69-12.63-7.03-16.97L7.03,112.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.74,101.95c0-3.81.02-26.84.02-28.48-.61-1.35-3.18-3.34-3.18-3.34v-9.81c0-.73,3.2-2.13,3.2-2.62v-1.69c0-.27-1-.73-1-.73h-4.52V23.23l-2.29-10.74h-1.52l-2.3,10.74-.03,32.06h-4.52s-1,.44-1,.73v1.69c0,.47,3.18,1.9,3.2,2.62v9.81s-2.59,1.96-3.2,3.32c0,1.64-.03,24.67-.03,28.5s3.29,5.57,3.29,5.57h10.57s3.29-1.74,3.29-5.57l.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.74,101.95c0-3.81.02-26.84.02-28.48-.61-1.35-3.18-3.34-3.18-3.34v-9.81c0-.73,3.2-2.13,3.2-2.62v-1.69c0-.27-1-.73-1-.73h-15.17s-1,.46-1,.73v1.69c0,.47,3.18,1.9,3.2,2.62v9.81s-2.59,1.96-3.2,3.32c0,1.64-.03,24.67-.03,28.5s3.29,5.57,3.29,5.57h10.57s3.29-1.74,3.29-5.57h.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.56,78.05c0-.86-.08-9.25-.19-18.71h0c0-8.09,0-15.06-.02-16.63-.05-4.18,10.35-6.15,9.16-15.5-.86-6.89-7.27-14.33-10.67-14.73l2.52,10.65-3.54,3.61-5.44.88-4.08-1.61-2.98-10.97c-3.73,1.91-5.03,12.73-3.35,17.63,1.69,4.89,7.45,7.3,7.47,9.28,0,.86.08,9.25.19,18.71h0c0,8.09,0,15.06.02,16.63.05,4.18-10.35,6.15-9.16,15.5.86,6.89,7.27,14.33,10.67,14.73l-2.52-10.65,3.54-3.61,5.44-.88,4.08,1.61,2.98,10.97c3.73-1.91,5.03-12.73,3.35-17.63-1.69-4.89-7.45-7.3-7.47-9.28Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/Start.e5aef205eadb63672d4925e8fe90d46a.svg";
export { ForwardRef as ReactComponent };